import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconBookmark = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66683 7C8.48273 7 8.3335 7.14924 8.3335 7.33333V16.0568L11.4189 13.8529C11.7666 13.6046 12.2337 13.6046 12.5814 13.8529L15.6668 16.0568V7.33333C15.6668 7.14924 15.5176 7 15.3335 7H8.66683ZM6.3335 7.33333C6.3335 6.04467 7.37817 5 8.66683 5H15.3335C16.6222 5 17.6668 6.04467 17.6668 7.33333V18C17.6668 18.3746 17.4575 18.7178 17.1244 18.8892C16.7913 19.0606 16.3904 19.0315 16.0856 18.8137L12.0002 15.8956L7.91473 18.8137C7.60992 19.0315 7.20899 19.0606 6.87591 18.8892C6.54284 18.7178 6.3335 18.3746 6.3335 18V7.33333Z"
        />
      </svg>
    );
  }
);
